module.exports = __webpack_public_path__ + "media/images/front/amazon_pay-dbb1497283d2a77611585f2cc93b3b88.png";